import { VerifyShopService } from '../services/verify-shop.service';
import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { LocalStorageService } from '@us/web/shared/data-access';
import { getStringValue } from '@us/web/shared/utils';
import { isNil } from 'lodash';
import { map, Observable, tap } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ValidateShopIdGuard {
    private readonly router = inject(Router);
    private readonly localStorage = inject(LocalStorageService);
    private readonly verifyShopService = inject(VerifyShopService);

    canActivate(
        route: ActivatedRouteSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const currentShopId = this.localStorage.getItem('shop_id');
        let requestShopId: string | null = getStringValue(route.queryParams['id']);
        const tableId = Number(route.queryParams['tableId']);

        if (requestShopId !== null && requestShopId.includes('/')) {
            // ? Payon payment callback
            requestShopId = (requestShopId as string).split('/')[0];
        }

        if (!isNil(requestShopId) && requestShopId !== currentShopId) {
            console.log('localStorage.setItem shop_id: ' + requestShopId);
            this.localStorage.setItem('shop_id', requestShopId);
            return true;
        }

        if (!isNil(currentShopId)) {
            return true;
        }

        if (tableId) {
            return this.verifyShopService.getShopIdByTableId({ table_id: tableId }).pipe(
                tap({
                    next: ({ shop_id: shopId }) => {
                        if (shopId) {
                            console.log('localStorage.setItem shop_id: ' + shopId);
                            this.localStorage.setItem('shop_id', shopId);
                        }
                    },
                    error: () => {
                        this.router.navigate(['/unavailable']);
                    }
                }),
                map(({ shop_id: shopId }) => !!shopId)
            );
        }
        this.router.navigate(['/unavailable']);
        return false;
    }
}
